import classNames from "classnames";
import ReactModal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import Portal from "../Portal";

import "./styles.sass";

type ModalProps = {
  children: React.ReactNode;
  className?: string;
  isOpen: boolean;
  lock?: boolean;
};

const Modal = (props: ModalProps) => {
  const { children, className, isOpen, lock = false } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    if (isOpen) {
      navigate(location.pathname);
    }
  };

  const classModal = classNames("Modal", className);

  return (
    <Portal>
      <ReactModal
        ariaHideApp={false}
        isOpen={isOpen}
        shouldCloseOnOverlayClick={!lock}
        onRequestClose={handleClose}
        className={classModal}
        closeTimeoutMS={10}
      >
        {children}
      </ReactModal>
    </Portal>
  );
};

export default Modal;
